import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { CheckColumns } from './Helper/CheckColumns'
import styled from 'styled-components'
import InvalidHeader from './invalidHeader'
const defaultMsg = {
    status: 'Error',
    type: null,
    details: []
} as MsgError

export interface MsgErrorHeader {
    status: string
    type: TypesError.Header
    details: ErrorDetailsHeader[]
}
export interface MsgErrorRows {
    status: string
    type: TypesError.Rows
    details: ErrorDetailsRows[]
}

export enum TypesError {
    Rows = 'Rows',
    Header = 'Header'
}

export interface ErrorDetailsHeader {
    message: string
    expected: string[]
    given: string[]
}
export interface ErrorDetailsRows {
    status: string
    messages: string[]
    columnName: string
    type: string
}

type MsgError = MsgErrorRows | MsgErrorHeader

export default function StatusResponse({ onClick, msg = JSON.stringify(defaultMsg), show = true, status = 400 }) {
    //Some of the returned messages aren't really a JSON so this raises an unexpected error for the user crashing the interface.
    //This is a temporary fix until the team can discuss how to proceed with this error handling.
    const parseMsg = (msgString: string): MsgError => {
        try {
            return JSON.parse(msgString)
        } catch (err) {
            return defaultMsg
        }
    }

    const [msgObj, setMsg] = useState<MsgError>(parseMsg(msg))

    useEffect(() => {
        setMsg(parseMsg(msg))
    }, [msg])

    const Response = {
        400: (
            <>
                <i className="far fa-exclamation-triangle" style={{ color: 'var(--yellow-700)' }}></i>{' '}
                <b style={{ color: 'var(--yellow-700)' }}>File does not Match the Template Settings</b>{' '}
            </>
        ),
        430: (
            <>
                {' '}
                <i className="far fa-exclamation-triangle" style={{ color: 'var(--yellow-700)' }}></i>{' '}
                <b style={{ color: 'var(--yellow-700)' }}>Incorrect Data Formatting</b>{' '}
            </>
        )
    }

    const messageType =
        msgObj?.type == TypesError.Header
            ? 'Header Invalid'
            : msgObj?.type == TypesError.Rows
            ? 'Rows Invalid'
            : msgObj?.status

    const messagesErros = msgObj?.details || []

    return (
        <Modal dialogClassName="modal-ok" show={show}>
            <Modal.Header>
                <Modal.Title>{Response[status] || 'Unknown error'}</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{background: 'var(--gray-200)'}}>
                <div
                    style={{
                        whiteSpace: 'pre-line',
                        wordWrap: 'break-word',
                        height: '300px',
                        overflowY: 'scroll',
 
                    }}
                >
                    <h5 style={{ marginBottom: '10px' }}>{/* <b>{messageType || 'Error'}</b> */}</h5>
                    <ul>
                        {messagesErros.map((messageEvent, index) => {
                            if (msgObj?.type == TypesError.Header) {
                                const eventIfo = messageEvent as ErrorDetailsHeader
                                const statusMessage = eventIfo?.message
                                const expected = eventIfo?.expected || []
                                const given = eventIfo?.given || []
                                const arrayResult = CheckColumns(expected, given)
                                

                                return <InvalidHeader key={index} response={arrayResult}/>
                                
                            } else if (msgObj?.type == TypesError.Rows) {
                                const eventIfo = messageEvent as ErrorDetailsRows
                                const status = eventIfo.status
                                const columnName = eventIfo.columnName
                                const type = eventIfo.type
                                const messages = eventIfo.messages
                                if (status === 'OK') {
                                    return null
                                }
                                return (
                                    <span
                                        style={{ display: 'flex', flexDirection: 'column' }}
                                        key={'collumns-info' + index}
                                    >
                                        <span>
                                            <h4>
                                                {columnName} ({type})
                                            </h4>
                                        </span>
                                        <span
                                            style={{
                                                display: messages.length > 0 ? 'auto' : 'none'
                                            }}
                                        >
                                            <b>Erros:</b>
                                            <ul key={'msg'}>
                                                {messages.map((msg, expectIndex) => (
                                                    <li key={`msg-row-${expectIndex}`}>{msg}</li>
                                                ))}
                                            </ul>
                                        </span>
                                    </span>
                                )
                            }
                            if (!!messageEvent?.message) {
                                return (
                                    <span
                                        style={{ display: 'flex', flexDirection: 'column' }}
                                        key={'collumns-info' + index}
                                    >
                                        <label>{messageEvent?.message}</label>
                                    </span>
                                )
                            }
                        })}
                    </ul>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-primary" onClick={onClick}>
                    OK
                </button>
            </Modal.Footer>
        </Modal>
    )
}

const TableContainer = styled.table`
    width: 95%;
    height: 100%;
    display: table;
    align-items: center;
    color: var(--gray-800);
    border-radius: 4px;

    table,
    th,
    td {
        border: 1px solid var(--gray-300);
    }

    td i {
        padding-right: 4px;
    }

    .tableHeader {
        height: 32px;

        .headerRow {
            .headerText {
                padding: 8px;
                width: 50%;
                font-weight: 600;
                font-size: 16px;
                line-height: 24px;
                background: var(--gray-100);
            }
        }
    }

    .main {
        td {
            height: 40px;
            padding: 8px;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
        }
        .mainRow {
            /* font-weight: 400;
            font-size: 16px;
            line-height: 24px; */

            .givenColumn {
                width: 50%;
            }

            .expectedColumn {
                width: 50%;

                i {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 24px;
                    color: var(--green-700);
                }

                span {
                }
            }

            .expectedColumnError {
                width: 50%;

                i {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 24px;
                    color: var(--red-700);
                }

                span {
                }
            }
        }
    }
`
